/* ============================================================
   MOONRISE — Quantity stepper custom element
   Reference: moon-rise-framer/script.js lines 777-806
     - +/− buttons clamp to [min, max]
     - Type-in restricted to digits, blur re-clamps
     - Keyboard ArrowUp / ArrowDown increment / decrement
     - Dispatches a bubbling `change` event so <product-form> can react
   ============================================================ */

(function () {
  'use strict';

  if (customElements.get('quantity-stepper')) return;

  class QuantityStepper extends HTMLElement {
    connectedCallback() {
      this.minus = this.querySelector('[data-qty-minus]');
      this.plus = this.querySelector('[data-qty-plus]');
      this.input = this.querySelector('[data-qty-input]');
      if (!this.input || !this.minus || !this.plus) return;

      this.min = parseInt(this.dataset.min, 10);
      if (isNaN(this.min)) this.min = 1;
      this.max = parseInt(this.dataset.max, 10);
      if (isNaN(this.max)) this.max = 99;

      this.minus.addEventListener('click', this._step.bind(this, -1));
      this.plus.addEventListener('click', this._step.bind(this, 1));

      this.input.addEventListener('input', this._sanitize.bind(this));
      this.input.addEventListener('blur', this._clampAndCommit.bind(this));
      this.input.addEventListener('keydown', this._onKeydown.bind(this));
    }

    _getValue() {
      var n = parseInt(this.input.value, 10);
      if (isNaN(n)) return this.min;
      return n;
    }

    _clamp(n) {
      if (n < this.min) return this.min;
      if (n > this.max) return this.max;
      return n;
    }

    _step(delta) {
      var n = this._clamp(this._getValue() + delta);
      if (String(n) === this.input.value) return;
      this.input.value = n;
      this._emit();
    }

    _sanitize() {
      this.input.value = this.input.value.replace(/[^0-9]/g, '');
    }

    _clampAndCommit() {
      var n = this._clamp(this._getValue());
      this.input.value = n;
      this._emit();
    }

    _onKeydown(e) {
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        this._step(1);
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        this._step(-1);
      }
    }

    _emit() {
      this.dispatchEvent(new CustomEvent('change', {
        bubbles: true,
        detail: { value: this._getValue() }
      }));
    }
  }

  customElements.define('quantity-stepper', QuantityStepper);
})();
